export default __webpack_public_path__ + "static/media/Group 2104.d6e362bd.png";